import React, { useEffect } from "react";
import DataTable from "react-data-table-component";
import { useDispatch, useSelector } from "react-redux";
import { MContainer } from "../../element/Elemens";
import { fetchByStreamStatistic } from "../../redux/actions/streamActions";

const columns = [
  {
    name: "Oqim",
    selector: (row) => row.desc || "—"
  },
  {
    name: "Tashrif",
    selector: (row) => row.visits?.count || 0 // Fallback qiymati
  },
  {
    name: "Yangi",
    selector: (row) => row.new?.count || 0
  },
  {
    name: "Qabul Qilindi",
    selector: (row) => row.accepted?.count || 0
  },
  {
    name: "Yetkazilmoqda",
    selector: (row) => row.sent?.count || 0
  },
  {
    name: "Yetkazib Berildi",
    selector: (row) => row.delivered?.count || 0
  },
  {
    name: "Qayta Qo'ngiroq",
    selector: (row) => row.pending?.count || 0
  },
  {
    name: "Spam",
    selector: (row) => row.spam?.count || 0
  },
  {
    name: "Qaytib Keldi",
    selector: (row) => row.cancelled?.count || 0
  },
  {
    name: "HOLD",
    selector: (row) => row.hold?.count || 0
  },
  {
    name: "Arxivlandi",
    selector: (row) => row.archieved?.count || 0
  }
];

const MyRequests = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchByStreamStatistic());
  }, []);

  const streamByStatic = useSelector((state) => state.stream.list);
  const streamMeta = useSelector((state) => state.stream.meta);
  const { loading } = useSelector((state) => state.stream);

  const handlePageChange = (page) => {
    dispatch(fetchByStreamStatistic({ page: page, per_page: 10 }));
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    dispatch(fetchByStreamStatistic({ page: page, per_page: newPerPage }));
  };

  const paginationComponentOptions = {
    rowsPerPageText: "Oqimlar bo'yicha hisobot",
    rangeSeparatorText: "dan",
    selectAllRowsItem: true,
    selectAllRowsItemText: "Barchasi"
  };

  return (
    <MContainer>
      <DataTable
        columns={columns}
        data={streamByStatic || []}
        noHeader
        defaultSortField="id"
        defaultSortAsc={false}
        pagination
        paginationServer
        highlightOnHover
        progressPending={loading}
        paginationComponentOptions={paginationComponentOptions}
        paginationTotalRows={streamMeta.total || 100}
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
      />
    </MContainer>
  );
};

export default MyRequests;
